import type {
  CookieCategory,
  CookieRecord,
} from '../../../../services/cookieTranslationService/types'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { QuestionMarkIcon } from '#src/assets/ui/icons/QuestionMarkIcon.tsx'
import { PolicySectionCompanyInfo } from '#src/assets/ui/overview/components/CompanyInfo.tsx'
import { PolicySectionConsent } from '#src/assets/ui/overview/components/Consent.tsx'
import { PolicySectionControllerInfo } from '#src/assets/ui/overview/components/ConstrollerInfo.tsx'
import { PolicySectionOverview } from '#src/assets/ui/overview/components/Overview.tsx'
import { PolicySectionTypes } from '#src/assets/ui/overview/components/SectionTypes.tsx'
import { PolicySectionSettings } from '#src/assets/ui/overview/components/Settings.tsx'
import { ExpandableSection } from '#src/assets/ui/overview/ExpandableSection.tsx'
import type { SiteConfig } from '#src/models/site-configs/siteConfigs.ts'

export function PolicySection({
  t,
  locale,
  siteConfig,
  cookiesByCategory,
}: {
  t: CookieConsentTranslator
  locale: string
  siteConfig: SiteConfig
  cookiesByCategory: Record<CookieCategory, Array<CookieRecord>>
}) {
  return (
    <ExpandableSection
      icon={<QuestionMarkIcon />}
      title={t('howWeUseCookiesTitle')}
    >
      <PolicySectionOverview t={t} />
      <PolicySectionControllerInfo t={t} siteConfig={siteConfig} />
      <PolicySectionConsent t={t} />
      <PolicySectionTypes
        t={t}
        siteConfig={siteConfig}
        cookiesByCategory={cookiesByCategory}
      />
      <PolicySectionSettings t={t} siteConfig={siteConfig} />
      <PolicySectionCompanyInfo t={t} locale={locale} siteConfig={siteConfig} />
    </ExpandableSection>
  )
}
